<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col cols="12">
            <v-row justify="center">
              <img class="slide-in-fwd-center" src="/img/orion.png" height="200" width="200">
            </v-row>
          </v-col>
          <v-col cols="12">
            <h1 class="title mt-2 text-center">La emisora que presenta a Jesús</h1>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  mounted () {
    const self = this
    setTimeout(() => {
      self.$router.push({ name: 'main' })
    }, 3000)
  }
}
</script>

<style>
.rotate-center {
  animation: rotate-center 0.6s ease-in-out 1s both;
}
.slide-in-fwd-center {
  animation: slide-in-fwd-center 0.6s both;
}
@keyframes rotate-center {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes slide-in-fwd-center {
  0% {
    -webkit-transform: translateZ(-1400px);
    transform: translateZ(-1400px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@keyframes slide-in-fwd-center {
  0% {
    -webkit-transform: translateZ(-1400px);
    transform: translateZ(-1400px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

</style>
